import { Card } from "@/components/ui/card";
import { getValidHttpUrl } from "@/lib/url";

interface FacebookPreviewProps {
  metaTags: {
    og_title?: string;
    og_description?: string;
    og_image?: string;
    og_url?: string;
  };
}

export default function FacebookPreview({ metaTags }: FacebookPreviewProps) {
  const { og_title, og_description, og_image, og_url } = metaTags;
  const ogImageUrl = getValidHttpUrl(og_image);

  let hostname = "";
  try {
    if (og_url) {
      const url = new URL(og_url);
      hostname = url.hostname.replace("www.", "");
    }
  } catch {
    // If URL is invalid, leave hostname empty
  }

  return (
    <Card className="p w-full max-w-lg gap-0 overflow-hidden py-0">
      {ogImageUrl ? (
        <img src={ogImageUrl} alt={og_title ?? ""} className="aspect-[1.91/1] w-full object-cover" />
      ) : (
        <div className="flex h-64 w-full items-center justify-center bg-gray-100 dark:bg-gray-800">
          <p className="text-gray-500 dark:text-gray-300">No image available</p>
        </div>
      )}
      {ogImageUrl ? (
        <div className="border-t border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-800">
          <p className="truncate text-xs text-gray-500 uppercase dark:text-gray-400">{hostname}</p>
          <h3 className="truncate text-base font-semibold text-gray-900 dark:text-gray-100">{og_title}</h3>
          <p className="line-clamp-1 text-sm text-gray-500 dark:text-gray-400">{og_description}</p>
        </div>
      ) : null}
    </Card>
  );
}
